// extracted by mini-css-extract-plugin
export default {"container":"aK5Nv3AQWAONIoJRDHqj","title":"cCHhsPhuPvnvkerBxLAG","subtitle":"uZJNbCoM4QCp4YVihG_w"};